import { combineReducers } from "redux";

import { GetInstitutionsReducer } from "./getInstitutions/reducer";
import { GetTokenReducer } from "./getToken/reducer";

export const PayWithAppReducer = combineReducers({
  intitutions: GetInstitutionsReducer,
  token: GetTokenReducer,
});
